import { IInvoiceDealValidationStatePlgExternal3 } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  BlockedByFeature,
  notAvailablePropExceptIn
} from '../../../featureToggles/features/utils';
import { Features } from '../../../featureToggles/features';
import { fetchInvoiceDealValidation } from './invoiceDealValidation.thunks';
import { ApiError } from '../../../services/api';

const initialState: IInvoiceDealValidationStatePlgExternal3 = notAvailablePropExceptIn({
  expected: {
    loading: false,
    canContinue: false,
    error: undefined
  },
  availableIn: [Features.PlgExternal3]
});

const invoiceDealValidationSlices = createSlice({
  name: 'invoiceDealValidation',
  initialState,
  reducers: {
    clearInvoiceDealValidations: (state: IInvoiceDealValidationStatePlgExternal3): IInvoiceDealValidationStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      return {
        loading: false,
        canContinue: false,
        error: undefined
      };
    }
  },
  extraReducers: {
    [fetchInvoiceDealValidation?.pending.type]: (state: IInvoiceDealValidationStatePlgExternal3) => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = true;
      state.error = undefined;
      state.canContinue = false;
      return state;
    },
    [fetchInvoiceDealValidation?.fulfilled.type]: (state: IInvoiceDealValidationStatePlgExternal3) => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      state.error = undefined;
      state.canContinue = true;
      return state;
    },
    [fetchInvoiceDealValidation?.rejected.type]: (state: IInvoiceDealValidationStatePlgExternal3, action: PayloadAction<ApiError>) => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.loading = false;
      state.canContinue = false;
      if (typeof action.payload === 'object' && action.payload.message) {
        state.error = action.payload;
      }
      return state;
    }
  }
});

export const actions = {
  ...invoiceDealValidationSlices.actions
};

export default invoiceDealValidationSlices.reducer;
